export default __webpack_public_path__ + "static/media/linkedin_icon.32e20978.svg";